import { CurrencyPipe } from '@angular/common';
import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
//import { ToastrService } from 'ngx-toastr';
import { title } from 'process';
import { AppInjectorService } from 'src/app/app-injector.service';
import { BaseComponent } from 'src/app/framework/components/base.component';
import Swal from 'sweetalert2';
import { AlertDialogComponent } from './alert/alertdialog.component';
import { DialogComponent } from './dialog/dialog.component';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export function TRANSLATE(str: string) {
  return str;
}
@Component({
  selector: 'app-basecomponent',
  template: '',
  providers: [CurrencyPipe]

})
export class FeaturesBaseComponent extends BaseComponent implements OnInit, OnDestroy {

  alert;


  constructor() {
    super();
  }


  ngOnInit() {
    super.ngOnInit();
    const injector = AppInjectorService.getInstance().getInjector();
    const dialog = injector.get(MatDialog);
    const ngZone = injector.get(NgZone);

    this.eventSubscriptions.push(this.alertService.onAlert().subscribe(alert => {
      ngZone.run(() => {
        console.log(alert);
        // Swal.fire(
        //   {
        //     title: 'Failure',
        //     text: alert.message,
        //     icon: 'error',
        //     timer: 2000
        //   }
        // )
        //
        this.toastrService.error(alert.message,'Failure', {
          timeOut: 3000,
        });
        //
        // const dialogRef = dialog.open(AlertDialogComponent, {
        //   data: {
        //     message: `Someting went wrong: ${alert.message}`,
        //     buttonText: {
        //       cancel: 'OK'
        //     }
        //   },
        // });
      })
    }));
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
